import { FOIL_COLOR_LABELS } from '~/cards/constants/foilColorLabels';

export const getFoilColorLabel = (foilColor: string): string | undefined => {
  const key = foilColor.toLowerCase();
  return foilColor && key in FOIL_COLOR_LABELS
    ? FOIL_COLOR_LABELS[key as keyof typeof FOIL_COLOR_LABELS]
    : undefined;
};
